export default socket => store => next => action => {
  if (action.meta && action.meta.remote) {
    action.id = socket.id
    socket.emit("action", action)
  }
  return next(action)
}


// WEBPACK FOOTER //
// ./src/remote_action_middleware.js